import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import NotificationService from "../../services/notification.service";

// get notifications
export const getNotificationsFromApi: any = createAsyncThunk(
  "notifications/getNotifications",
  async () => {
    const response: any = await NotificationService.getNotifications();
    if (response?.response?.status >= 400) {
      throw new Error(response?.response?.data?.error);
    }
    if (Array.isArray(response)) return response;
    return [];
  }
);

const initialState: any = {
  notifications: [],
  status: "idle",
  error: null,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotificationsFromApi.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(getNotificationsFromApi.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.notifications = action.payload;
    });
    builder.addCase(getNotificationsFromApi.rejected, (state, action) => {
      state.status = "failed";
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});

export const getNotifications = (state: RootState) =>
  state.notification.notifications;

export default notificationSlice.reducer;
